/**
 * O ITEM DO RODAPÉ DAS GAVETAS (Notificações, Relatar algo) — 21/10/2026.
 *
 * Os itens de uma gaveta têm o ícone a 16 px da borda do painel e 12 px entre o ícone e o texto, em todos os papéis. Os do
 * rodapé moram num invólucro `px-2` (8 px), e por isso o item tem `px-2` (mais 8) e `gap-3` (12). Antes eram `px-3` e
 * `gap-2`: o ícone a 20 px e o texto a 8 px dele, à direita dos itens de cima. Uma constante só, usada pelo sino
 * (`SinoDeNotificacoes`) e pelo "Relatar algo" das quatro gavetas — quatro cópias divergiriam na primeira mudança.
 */
export const ITEM_DO_RODAPE_DA_GAVETA =
  'flex w-full items-center gap-3 rounded-md px-2 py-2 text-sm min-h-[44px] text-gray-700 hover:bg-gray-100';
